import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%'
  },
  card: {
    border: `1px dashed ${theme.palette.grey[600]}`,
    borderRadius: 8,
    padding: theme.spacing(3),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%'
  },
  contentBox: {
    padding: theme.spacing(2),
    borderRadius: 8,
    width: '100%',
    marginBottom: theme.spacing(2),
    textAlign: 'center'
  },
  bankNameRight: {
    float: 'right',
    fontWeight: 'bold',
    fontSize: '1rem'
  },
  bankNameLeft: {
    float: 'left',
    fontWeight: 'bold',
    fontSize: '1rem'
  },
  detail: {
    clear: 'both',
    marginTop: theme.spacing(1),
    fontSize: '0.95rem'
  },
  downloadButton: {
    // color: '#d32f2f',
    // borderColor: '#d32f2f',
    // textTransform: 'none'
  }
}))

export default useStyles
